import { render, staticRenderFns } from "./WmsSettingsList.vue?vue&type=template&id=25fdf434"
import script from "./WmsSettingsList.vue?vue&type=script&lang=js"
export * from "./WmsSettingsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports